export default __webpack_public_path__ + "static/media/work_blog-products.1b0da15f.jpg";